import { render, staticRenderFns } from "./ChooseWebApp.modal.vue?vue&type=template&id=5b8b1c85"
import script from "./ChooseWebApp.modal.vue?vue&type=script&lang=ts"
export * from "./ChooseWebApp.modal.vue?vue&type=script&lang=ts"
import style0 from "./ChooseWebApp.modal.vue?vue&type=style&index=0&id=5b8b1c85&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports